$(document).ready(function() {
    $(document).on('click', '.sym-more', function(e){
        e.preventDefault();
        var locationId = $('.page-location-id').val(),
            isNumber = $(this).attr('data-isNumber'),
            oldFilter = $(this).attr('data-oldFilter'),
            filter = $(this).attr('data-filter'),
            offset = $(this).attr('data-result'),
            total = $(this).attr('data-total-result'),
            urlRoute = Routing.generate("ojd_get_more_member_item",{
                'locationId': locationId,
                'offset': offset,
                'alphabet': filter,
                'isNumber': isNumber,
                'oldFilter': oldFilter,
        });

        $('.bloc-loading').show();
        $.ajax({
            url : urlRoute,
            method: 'POST',
            dataType: "json",
            success: function ( response ) {
                $('.bloc-loading').hide();
                $('.ajax_update').before(response);
                offset = parseInt(offset)+1;
                $('.sym-more').attr('data-result', offset);
                $('.sym-more').attr('data-oldFilter', $('.ancre').last().html());
                if($('.wrapper-membre').length == total){
                    $('.ajax_update').hide();
                }
            },
            error: function () {
                alert('erreur !!');
            }
        });
    });

    $(document).on('keyup', '.query-member', function(){
       var terms = $(this).val(),
           locationId = $('.page-location-id').val(),
           nbrTotal = 0,
           urlRoute = Routing.generate("ojd_search_member_item",{
               'locationId': locationId,
               'terms': terms.toUpperCase()
           });
       $('.bloc-member').remove();
        $('.bloc-loading').show();
        $.ajax({
            url : urlRoute,
            method: 'POST',
            dataType: "json",
            success: function ( response ) {
                $('.bloc-member').remove();
                $('.bloc-loading').hide();
                $('.ajax_update').before(response);
                if(terms != '') {
                    $('.ajax_update .text-center').hide();
                    nbrTotal = $('.wrapper-membre').length;
                    $('.nbre-res').html(nbrTotal + " adhérents au total");
                }else{
                    $('.ajax_update .text-center').show();
                    nbrTotal = $('.sym-more').attr('data-total-result');
                    $('.nbre-res').html(nbrTotal + " adhérents au total");
                }
            },
            error: function () {
                alert('erreur !!');
            }
        });
    });

    $(document).on('click', '.search-member', function(e){
        e.preventDefault();
        var terms = $('.query-member').val(),
            locationId = $('.page-location-id').val(),
            urlRoute = Routing.generate("ojd_search_member_item",{
                'locationId': locationId,
                'terms': terms.toUpperCase()
            });
        $('.bloc-member').remove();
        $('.bloc-loading').show();
        $.ajax({
            url : urlRoute,
            method: 'POST',
            dataType: "json",
            success: function ( response ) {
                $('.bloc-member').remove();
                $('.bloc-loading').hide();
                $('.ajax_update').before(response);
                if(terms != '') {
                    $('.ajax_update .text-center').hide();
                    nbrTotal = $('.wrapper-membre').length;
                    $('.nbre-res').html(nbrTotal + " adhérents au total");
                }else{
                    $('.ajax_update .text-center').show();
                    nbrTotal = $('.sym-more').attr('data-total-result');
                    $('.nbre-res').html(nbrTotal + " adhérents au total");
                }
            },
            error: function () {
                alert('erreur !!');
            }
        });
    });

});